var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getShowResources)?_c('lesson-resources-by-categories',{attrs:{"media":_vm.getMedia},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var resource = ref.resource;
return [_c('lesson-resource-item',{attrs:{"resource":resource}})]}}],null,false,1608921528)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }